<template>
  <div id="automation-creation-toggles">
    <binary
      class="scs-input"
      v-for="(toggle, index) in toggles"
      :key="index"
      :heading="toggle.heading"
      :selected="toggle.selected"
      :option1="toggle.option1"
      :option2="toggle.option2"
      @toggle="toggle.action"
    />
  </div>
</template>
<script>
import Binary from "@/Components/Elements/Binary.vue";
export default {
  data() {
    return {
      values: {
        timing: "Timed",
        trigger: "Event Date",
        approval: "Not Required",
      },
    };
  },
  computed: {
    toggles() {
      return [
        {
          heading: "Timing",
          option1: "Immediate",
          option2: "Timed",
          selected: this.values.timing,
          action: this.timingToggle,
        },
        {
          heading: "Trigger",
          option1: "Event Date",
          option2: "Booking Date",
          selected: this.values.trigger,
          action: this.triggerToggle,
        },
        {
          heading: "Approval",
          option1: "Required",
          option2: "Not Required",
          selected: this.values.approval,
          action: this.approvalToggle,
        },
      ];
    },
  },
  methods: {
    timingToggle(value) {
      this.values.timing = value;
      switch (value) {
        case "Immediate":
          this.$emit("immediate-input", true);
          break;
        case "Timed":
          this.$emit("immediate-input", false);
          break;
      }
    },
    triggerToggle(value) {
      this.values.trigger = value;
      switch (value) {
        case "Event Date":
          this.$emit("trigger-input", "event-date");
          break;
        case "Booking Date":
          this.$emit("trigger-input", "book-date");
          break;
      }
    },
    approvalToggle(value) {
      this.values.approval = value;
      switch (value) {
        case "Required":
          // a parameter of 'required' should pass a false value to 'approved'
          this.$emit("approval-input", false);
          break;
        case "Booking Date":
          this.$emit("approval-input", true);
          break;
      }
    },
  },
  created() {},
  components: {
    Binary,
  },
  emits: ["immediate-input", "trigger-input", "approval-input"],
  props: [],
};
</script>
<style scoped>
.scs-input {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 25px;
}
</style>
